import React,  { useContext } from "react";
import { Box, Dialog, DialogContent, DialogTitle } from "@material-ui/core";
import Parser from 'html-react-parser';
// import theme from "../../../theme";
import { storeContext } from "../../provider/Provider";
import { digitalPRActions } from "../../../store/digital-pr-reducer";

const ClientNotesDialog = () => {
   const { state, dispatch } = useContext(storeContext);

   const handleClose = () => {
      
      dispatch({
         type: digitalPRActions.SET_SELECTED_CLIENT_NOTE,
         payload: { 
            selectedClientNote: '',
         }
      })
      dispatch({
         type: digitalPRActions.SET_CLIENT_NOTES_OPEN,
         payload: { 
            clientNotesOpen: false,
         }
      })
   }

   return (
      <Dialog
         open={state.digitalPR.clientNotesOpen}
         onClose={handleClose}
      >
         <DialogTitle style={{background: "#e0e0e0"}}>
            Client Note
         </DialogTitle>
         <DialogContent style={{minWidth: "200px", maxWidth: "600px"}}>
            <Box textAlign='left' my={3} mx={2}>
               {Parser(state.digitalPR.selectedClientNote)}
            </Box>
         </DialogContent>
      </Dialog>)
}

export default ClientNotesDialog
